import Image from 'next/future/image';
import Link from 'next/link';
import cn from 'classnames';
import { MAP_BUYBACK_BRAND_LOGO, MAP_BUYBACK_CATEGORY_LOGO } from './helpers';

export type NavigationItem = {
  title: string;
  imageLink: string;
  handle: string;
};

const NavigationBox = (props: {
  title: string;
  link: string;
  image: StaticImageData;
  isMainNav?: boolean;
}) => {
  const { title, link, image, isMainNav } = props;

  return (
    <Link href={link} passHref>
      <a
        className={cn(
          'flex cursor-pointer flex-col items-center justify-center ',
          {
            'w-[50%] border-b-[2px] border-r-[2px] border-t-0 border-l-0 py-4 xxs:py-6 md:w-[22%] md:border-r-0 md:py-8 md:[&:not(:last-child)]:border-r-2 md:[&:not(:last-child)]:border-gray-200':
              isMainNav,
          },
          {
            'w-[33.33%] border-r-[2px] border-t-0 border-l-0 border-b-[2px] border-gray-200 py-3 xxs:py-4 md:w-[20%] md:py-6':
              !isMainNav,
          },
        )}
      >
        <div
          className={cn('relative', {
            'h-12 w-12 xxs:h-16 xxs:w-16 xs:h-20 xs:w-20 sm:h-24 sm:w-24':
              !isMainNav,
            'h-16 w-16 xxs:h-20 xxs:w-20 xs:h-24 xs:w-24': isMainNav,
          })}
        >
          <Image
            src={image}
            alt="navigation"
            className="h-full w-full object-contain"
          />
        </div>
        <div
          className={cn(
            'mt-2 font-semibold text-gray-700 sm:mt-0',
            {
              'text-base xxs:text-lg md:text-xl': isMainNav,
            },
            {
              'text-xs xxs:text-sm xs:text-base sm:text-lg': !isMainNav,
            },
          )}
        >
          {title}
        </div>
      </a>
    </Link>
  );
};

export default function Navigation(props: {
  isMainNav: boolean;
  items: Array<NavigationItem>;
}) {
  const { isMainNav, items } = props;

  if (items.length === 0) return null;

  return (
    <>
      <h3 className="mt-8 mb-3 text-center text-xl font-bold text-blue-500 xs:mb-4 sm:text-2xl">
        {`Which ${isMainNav ? `device` : `brand`} do you want to sell?`}
      </h3>
      <div
        className={cn('mb-12 flex flex-wrap items-center bg-white', {
          'justify-center ': isMainNav,
          'justify-start border-t-[2px] border-b-0 border-r-0 border-l-[2px] border-gray-200 ':
            !isMainNav,
        })}
      >
        {items.map((item) => {
          const image = isMainNav
            ? MAP_BUYBACK_CATEGORY_LOGO[item.imageLink]
            : MAP_BUYBACK_BRAND_LOGO[item.imageLink];

          return (
            <NavigationBox
              key={item.handle}
              title={item.title}
              image={image}
              link={item.handle}
              isMainNav={isMainNav}
            />
          );
        })}
      </div>
    </>
  );
}
